(function () {
  function loadYouTubeApi() {
    if (window.YT && window.YT.Player) return Promise.resolve(window.YT);
    if (window.__ckYouTubeApiPromise) return window.__ckYouTubeApiPromise;

    window.__ckYouTubeApiPromise = new Promise(function (resolve, reject) {
      var previousReady = window.onYouTubeIframeAPIReady;
      var timeout = window.setTimeout(function () {
        reject(new Error('YouTube player timed out'));
      }, 15000);

      window.onYouTubeIframeAPIReady = function () {
        if (typeof previousReady === 'function') previousReady();
        window.clearTimeout(timeout);
        resolve(window.YT);
      };

      var existing = document.querySelector('script[src="https://www.youtube.com/iframe_api"]');
      if (!existing) {
        var script = document.createElement('script');
        script.src = 'https://www.youtube.com/iframe_api';
        script.async = true;
        script.onerror = function () {
          window.clearTimeout(timeout);
          reject(new Error('YouTube player could not be loaded'));
        };
        document.head.appendChild(script);
      }
    });

    return window.__ckYouTubeApiPromise;
  }

  function pageMode() {
    var roots = document.querySelectorAll('[data-ck-independence]');
    var full = Array.prototype.some.call(roots, function (root) {
      return root.dataset.fullscreen === 'true';
    });
    document.body.classList.toggle('ck-id-page', full);
  }

  function init(root) {
    if (root.dataset.playerReady) return;
    root.dataset.playerReady = 'true';

    var player = root.querySelector('.ck-id__player');
    var panel = root.querySelector('[data-player-panel]');
    var toggle = root.querySelector('[data-player-toggle]');
    var previous = root.querySelector('[data-player-previous]');
    var next = root.querySelector('[data-player-next]');
    var progress = root.querySelector('[data-player-progress]');
    var miniProgress = root.querySelector('[data-player-mini-progress]');
    var elapsed = root.querySelector('[data-player-elapsed]');
    var duration = root.querySelector('[data-player-duration]');
    var title = root.querySelector('[data-player-title]');
    var artist = root.querySelector('[data-player-artist]');
    var barTitle = root.querySelector('[data-player-bar-title]');
    var barArtist = root.querySelector('[data-player-bar-artist]');
    var number = root.querySelector('[data-player-number]');
    var count = root.querySelector('[data-player-count]');
    var message = root.querySelector('[data-player-message]');
    var trackList = root.querySelector('[data-player-track-list]');
    var emptyState = root.querySelector('[data-player-empty]');
    var videoShell = root.querySelector('[data-youtube-shell]');
    var videoTarget = root.querySelector('[data-youtube-player]');
    var tracks = [];
    var trackButtons = [];
    var youtube = null;
    var youtubeReady = false;
    var pendingIndex = 0;
    var progressTimer = null;
    var wantsPlayback = false;
    var currentIndex = 0;

    function formatTime(seconds) {
      if (!isFinite(seconds) || seconds < 0) return '0:00';
      var minutes = Math.floor(seconds / 60);
      return minutes + ':' + String(Math.floor(seconds % 60)).padStart(2, '0');
    }

    function setMessage(text) {
      message.textContent = text || '';
      message.hidden = !text;
    }

    function setOpen(open) {
      player.classList.toggle('is-open', open);
      panel.setAttribute('aria-hidden', String(!open));
      toggle.setAttribute('aria-expanded', String(open));
    }

    function setPlaying(playing) {
      player.classList.toggle('is-playing', playing);
      var icon = toggle.querySelector('i');
      icon.className = playing ? 'ck-id__pause-icon' : 'ck-id__play-icon';
      toggle.setAttribute('aria-label', playing ? 'Pause music' : 'Play music');
      trackButtons.forEach(function (button, index) {
        button.querySelector('i').textContent = index === currentIndex && playing ? '▮▮' : '▶';
      });
      window.clearInterval(progressTimer);
      progressTimer = playing ? window.setInterval(updateProgress, 500) : null;
      updateProgress();
    }

    function updateProgress() {
      if (!youtubeReady || !youtube) return;
      var total = Number(youtube.getDuration()) || 0;
      var now = Number(youtube.getCurrentTime()) || 0;
      var percent = total ? now / total * 100 : 0;
      elapsed.textContent = formatTime(now);
      duration.textContent = formatTime(total);
      progress.max = String(total);
      progress.value = String(Math.min(now, total));
      progress.disabled = !total;
      progress.style.setProperty('--progress', percent + '%');
      miniProgress.style.width = percent + '%';
    }

    function playerState() {
      return youtubeReady && youtube ? youtube.getPlayerState() : -1;
    }

    function isCurrentlyPlaying() {
      return Boolean(window.YT && playerState() === window.YT.PlayerState.PLAYING);
    }

    function pausePlayback() {
      wantsPlayback = false;
      if (youtubeReady && youtube) youtube.pauseVideo();
      setPlaying(false);
    }

    function onPlayerStateChange(event) {
      if (!window.YT) return;
      if (event.data === window.YT.PlayerState.PLAYING) {
        wantsPlayback = true;
        setMessage('');
        setPlaying(true);
      } else if (event.data === window.YT.PlayerState.ENDED) {
        setPlaying(false);
        if (tracks.length) playTrack((currentIndex + 1) % tracks.length);
      } else if (event.data === window.YT.PlayerState.PAUSED || event.data === window.YT.PlayerState.CUED) {
        wantsPlayback = false;
        setPlaying(false);
      }
    }

    function createYouTubePlayer(index) {
      pendingIndex = index;
      videoShell.hidden = false;
      setMessage('Loading the official YouTube player…');

      loadYouTubeApi().then(function (YT) {
        if (!root.isConnected || youtube) return;
        youtube = new YT.Player(videoTarget, {
          width: '100%',
          height: '100%',
          videoId: tracks[pendingIndex].youtubeId,
          playerVars: {
            autoplay: 0,
            controls: 1,
            playsinline: 1,
            rel: 0,
            origin: window.location.origin
          },
          events: {
            onReady: function () {
              youtubeReady = true;
              root._ckYouTube = youtube;
              if (wantsPlayback && player.classList.contains('is-open')) {
                youtube.loadVideoById({ videoId: tracks[pendingIndex].youtubeId, startSeconds: 0 });
              } else {
                youtube.cueVideoById({ videoId: tracks[pendingIndex].youtubeId, startSeconds: 0 });
              }
              updateProgress();
            },
            onStateChange: onPlayerStateChange,
            onError: function () {
              setPlaying(false);
              setMessage('This official video cannot be played here. Choose another song from the playlist.');
            }
          }
        });
      }).catch(function () {
        setPlaying(false);
        setMessage('The YouTube player could not be loaded. Check your connection and try again.');
      });
    }

    function showTrack(index) {
      var track = tracks[index];
      if (!track) return;
      currentIndex = index;
      title.textContent = track.title;
      artist.textContent = track.artist || 'Aazaadi radio';
      barTitle.textContent = track.title;
      barArtist.textContent = track.artist || 'Aazaadi radio';
      number.textContent = String(index + 1).padStart(2, '0');
      trackButtons.forEach(function (button, itemIndex) {
        button.classList.toggle('is-current', itemIndex === index);
        button.querySelector('i').textContent = itemIndex === index && isCurrentlyPlaying() ? '▮▮' : '▶';
      });
    }

    function playTrack(index) {
      var track = tracks[index];
      if (!track) {
        setOpen(true);
        setMessage('Add official YouTube video IDs to the playlist manifest.');
        return;
      }
      showTrack(index);
      setMessage('');
      setOpen(true);
      videoShell.hidden = false;
      wantsPlayback = true;
      pendingIndex = index;
      if (!youtube) createYouTubePlayer(index);
      else if (youtubeReady) youtube.loadVideoById({ videoId: track.youtubeId, startSeconds: 0 });
    }

    function togglePlayback() {
      if (!tracks.length) {
        setOpen(true);
        setMessage('Add official YouTube video IDs to the playlist manifest.');
        return;
      }
      setOpen(true);
      videoShell.hidden = false;
      if (!youtube) {
        playTrack(currentIndex);
      } else if (!youtubeReady) {
        setMessage('Loading the official YouTube player…');
      } else if (playerState() === window.YT.PlayerState.PLAYING) {
        pausePlayback();
      } else {
        wantsPlayback = true;
        youtube.playVideo();
      }
    }

    function changeTrack(direction) {
      if (!tracks.length) {
        setOpen(true);
        setMessage('The playlist is still loading.');
        return;
      }
      playTrack((currentIndex + direction + tracks.length) % tracks.length);
    }

    function makeTrackButton(track, index) {
      var item = document.createElement('div');
      var button = document.createElement('button');
      var indexLabel = document.createElement('span');
      var text = document.createElement('span');
      var trackTitle = document.createElement('strong');
      var trackArtist = document.createElement('small');
      var state = document.createElement('i');
      item.setAttribute('role', 'listitem');
      button.type = 'button';
      indexLabel.textContent = String(index + 1).padStart(2, '0');
      trackTitle.textContent = track.title;
      trackArtist.textContent = track.artist || 'Aazaadi radio';
      state.textContent = '▶';
      state.setAttribute('aria-hidden', 'true');
      text.appendChild(trackTitle);
      text.appendChild(trackArtist);
      button.appendChild(indexLabel);
      button.appendChild(text);
      button.appendChild(state);
      button.addEventListener('click', function () { setOpen(true); playTrack(index); });
      item.appendChild(button);
      trackList.appendChild(item);
      return button;
    }

    function renderPlaylist(data) {
      var source = Array.isArray(data) ? data : data && Array.isArray(data.tracks) ? data.tracks : [];
      tracks = source.filter(function (track) {
        return track && typeof track.title === 'string' && track.title.trim() && typeof track.youtubeId === 'string' && /^[A-Za-z0-9_-]{11}$/.test(track.youtubeId.trim());
      }).map(function (track) {
        return { title: track.title.trim(), artist: typeof track.artist === 'string' ? track.artist.trim() : '', youtubeId: track.youtubeId.trim() };
      });
      trackList.innerHTML = '';
      trackButtons = tracks.map(makeTrackButton);

      var hasTracks = tracks.length > 0;
      trackList.hidden = !hasTracks;
      emptyState.hidden = hasTracks;
      previous.disabled = !hasTracks;
      next.disabled = !hasTracks;
      count.textContent = hasTracks ? tracks.length + ' songs' : 'Player ready';

      if (hasTracks) {
        setMessage('');
        showTrack(0);
      }
    }

    function loadPlaylist() {
      fetch(root.dataset.playlistManifest, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Playlist request failed');
          return response.json();
        })
        .then(renderPlaylist)
        .catch(function () { setMessage('The playlist file could not be loaded.'); });
    }

    toggle.addEventListener('click', function () { setOpen(true); togglePlayback(); });
    previous.addEventListener('click', function () { changeTrack(-1); });
    next.addEventListener('click', function () { changeTrack(1); });
    root.querySelector('[data-player-close]').addEventListener('click', function () { pausePlayback(); setOpen(false); });
    progress.addEventListener('input', function () {
      if (!youtubeReady || !youtube) return;
      youtube.seekTo(Number(progress.value), true);
      updateProgress();
    });
    root.addEventListener('keydown', function (event) { if (event.key === 'Escape') { pausePlayback(); setOpen(false); } });
    document.addEventListener('visibilitychange', function () { if (document.hidden) pausePlayback(); });
    loadPlaylist();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-ck-independence]').forEach(init);
    pageMode();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('[data-ck-independence]');
    if (root && root._ckYouTube && typeof root._ckYouTube.destroy === 'function') root._ckYouTube.destroy();
    requestAnimationFrame(pageMode);
  });
})();
